const requested = new Set<string>();

/**
 * Loads a catalog family from Google Fonts once, so the specimens in the chat show the real typeface. The catalog
 * only lists families that ship the Latin and Cyrillic subsets, and the browser fetches just the subsets a page uses.
 */
export const loadSiteBriefFont = (family: string): void => {
  if (typeof document === 'undefined' || requested.has(family)) {
    return;
  }
  requested.add(family);
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(family).replace(/%20/g, '+')}:wght@400;700&display=swap`;
  document.head.appendChild(link);
};

/** A CSS font stack for a catalog family, quoted because several names contain spaces or digits. */
export const fontStack = (family: string): string => `'${family.replace(/'/g, '')}', sans-serif`;
